import React, { useMemo } from 'react';
import { arrayOf, string, number, func, object } from 'prop-types';
import { contextPropTypes, trailPropTypes } from '../../../proptypes/shared';
import TrailResultCard from '../../cards/TrailResultCard';
import styles from './styles/styles.module.scss';
import River from '../../shared/River';
import ShowMoreCard from './ShowMoreCard';
import { isFavorite, isComplete, isVerified } from '../../../microapps/Community/utils/lists_helper';
import TrailRiverShimmer from '../../shimmers/TrailRiverShimmer';
import { HOME_PAGE_WIDTH_BREAKPOINT } from '../../../utils/constants/breakpoints';

const slickSettings = { slidesToShow: 4, lazyLoad: 'progressive', slidesToScroll: 4, speed: 750 };
const ARROW_STYLES = { next: styles.next, previous: styles.previous };
const TrailRiver = ({ hits, title, windowWidth, context, handleFavoriteClick, listItems, className, trailCardLinkRef }) => {
  const isWideScreen = useMemo(() => {
    return windowWidth && windowWidth >= HOME_PAGE_WIDTH_BREAKPOINT;
  }, [windowWidth]);

  if (!hits) {
    return <TrailRiverShimmer className={className} />;
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={`${styles.title} xlate-none`}>{title}</div>
      <div className={styles.riverContainer}>
        <River useSlick={isWideScreen} slickSettings={slickSettings} className={styles.riverClass} arrowStyles={ARROW_STYLES}>
          {hits.map((hit, idx) => {
            return (
              <div className={styles.trailCardContainer}>
                {hit.exploreMoreUrl ? (
                  <ShowMoreCard url={hit.exploreMoreUrl} />
                ) : (
                  <TrailResultCard
                    className={`${styles.trailCard} ${context.mobileBrowser ? '' : styles.hoverAnimation}`}
                    allowItemMoving={false}
                    context={context}
                    handleFavoriteClick={() => handleFavoriteClick(hit.type, hit.ID)}
                    idx={idx}
                    isCompleted={isComplete(hit.type, hit.ID, listItems)}
                    isFavorite={isFavorite(hit.type, hit.ID, listItems)}
                    isVerified={isVerified(hit.type, hit.ID, listItems)}
                    key={`trail-${hit.ID}`}
                    showFavoriteHeart
                    tabletBrowser={context.tabletBrowser}
                    trail={hit}
                    maxInitPhotos={1}
                    maxPhotos={1}
                    linkRef={trailCardLinkRef}
                  />
                )}
              </div>
            );
          })}
        </River>
      </div>
    </div>
  );
};

TrailRiver.propTypes = {
  hits: arrayOf(trailPropTypes),
  title: string,
  windowWidth: number,
  context: contextPropTypes.isRequired,
  handleFavoriteClick: func,
  listItems: object,
  className: string
};

TrailRiver.defaultProps = {
  hits: null,
  title: '',
  windowWidth: null,
  handleFavoriteClick: () => {},
  listItems: {},
  className: ''
};

export default TrailRiver;
